export const OffersActionTypes = {
  MAKE_OFFERS_REQUEST: "MAKE_OFFERS_REQUEST",
  SET_OFFERS_DATA: "SET_OFFERS_DATA",
  SET_OFFERS_DATA_CATEGORYWISE: "SET_OFFERS_DATA_CATEGORYWISE",
  SET_OFFERS_ERROR: "SET_OFFERS_ERROR",
};
